import { loginIcon, usersIcon } from "@excalidraw/excalidraw/components/icons";
import { useI18n } from "@excalidraw/excalidraw/i18n";
import { WelcomeScreen } from "@excalidraw/excalidraw/index";
import React from "react";

import { isDrawolaPlusSignedUser } from "../app_constants";
import { DRAWOLA_FEATURES } from "../drawola-features";

export const AppWelcomeScreen: React.FC<{
  onCollabDialogOpen: () => any;
  isCollabEnabled: boolean;
  // DRAWOLA:CUSTOM-START SHOW_LIVE_COLLAB availability
  /** `null` shows the entry normally; any other value disables it and explains why. */
  collabDisabledReason: string | null;
  // DRAWOLA:CUSTOM-END
}> = React.memo((props) => {
  const { t } = useI18n();
  // DRAWOLA:CUSTOM-START hide-upstream-plus-link
  // Upstream shows "go to Excalidraw+" (a link to app.excalidraw.com) for a
  // signed-in plus user. drawOla has no such account, so the heading is
  // always the plain one.
  const headingContent = (
    <>
      {t("welcomeScreen.app.center_heading")}
      <br />
      {t("welcomeScreen.app.center_heading_line2")}
      <br />
      {t("welcomeScreen.app.center_heading_line3")}
    </>
  );
  // DRAWOLA:CUSTOM-END

  return (
    <WelcomeScreen>
      <WelcomeScreen.Hints.MenuHint>
        {t("welcomeScreen.app.menuHint")}
      </WelcomeScreen.Hints.MenuHint>
      <WelcomeScreen.Hints.ToolbarHint />
      <WelcomeScreen.Hints.HelpHint />
      <WelcomeScreen.Center>
        {/* <WelcomeScreen.Center.Logo /> */}
        <WelcomeScreen.Center.Heading>
          {headingContent}
        </WelcomeScreen.Center.Heading>
        <WelcomeScreen.Center.Menu>
          <WelcomeScreen.Center.MenuItemLoadScene />
          <WelcomeScreen.Center.MenuItemHelp />
          {/* DRAWOLA:CUSTOM-START SHOW_LIVE_COLLAB */}
          {DRAWOLA_FEATURES.SHOW_LIVE_COLLAB &&
            props.isCollabEnabled &&
            (props.collabDisabledReason !== null ? (
              <WelcomeScreen.Center.MenuItem
                icon={usersIcon}
                shortcut={null}
                disabled
                title={props.collabDisabledReason}
                aria-label={props.collabDisabledReason}
                onSelect={() => {}}
              >
                {t("labels.liveCollaboration")}
              </WelcomeScreen.Center.MenuItem>
            ) : (
              <WelcomeScreen.Center.MenuItemLiveCollaborationTrigger
                onSelect={() => props.onCollabDialogOpen()}
              />
            ))}
          {/* DRAWOLA:CUSTOM-END */}
          {/* DRAWOLA:CUSTOM-START SHOW_SIGN_UP */}
          {DRAWOLA_FEATURES.SHOW_SIGN_UP && !isDrawolaPlusSignedUser && (
            <WelcomeScreen.Center.MenuItemLink
              href={`${
                import.meta.env.VITE_APP_PLUS_LP
              }/plus?utm_source=drawola&utm_medium=app&utm_content=welcomeScreenGuest`}
              shortcut={null}
              icon={loginIcon}
            >
              {t("labels.signUp")}
            </WelcomeScreen.Center.MenuItemLink>
          )}
          {/* DRAWOLA:CUSTOM-END */}
        </WelcomeScreen.Center.Menu>
      </WelcomeScreen.Center>
    </WelcomeScreen>
  );
});
